import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { GetUserMemberApplicationData } from "../../components/UserMembershipApplication/Api/services/Webservices";
import Header from "./Header";
import { ROUTE_BASE_URL } from "../../api/common";
import { FormCheck } from "react-bootstrap";
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import Footer from "./Footer";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { encryptSlug } from "../../util/encryption";
const UserMemberApplicationList = () => {

  const history = useHistory();
  const [isModal, setModal] = useState("");
  const [userMemberData, setUserMemberData] = useState([]);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [checkedItems, setCheckedItems] = useState({});

  useEffect(() => {
    GetUserMemberApplicationData()
      .then((res) => {
        setUserMemberData(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  const handleOpenModal = (item) => {
    console.log(item,'details');
    setSelectedApplication(item);
    setModal("Form Wizard modal");
    setCheckedItems({});
  };

  const handleCloseModal = () => {
    setCheckedItems({});
    setSelectedApplication(null);
    setModal("");
  };

  // Function to extract <li> elements from HTML content
  const extractListItems = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    return [...doc.querySelectorAll("li")].map((li) => li.innerText);
  };

  const handleCheckboxChange = (index) => {
    setCheckedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleOpenApplicationForm = (url) => {
    const totalItems = extractListItems(selectedApplication.description).length + extractListItems(selectedApplication.documents_description).length;
    const checkedCount = Object.keys(checkedItems).length;
    if (checkedCount < totalItems) {
      showToast("Please review all the necessary items and check the boxes before proceeding.", "error", 8000);
      return;
    }
    history.replace(url);
  };
  const [activeTab, setActiveTab] = useState('life');
  const handleOpenALMApplication = () => {
    setActiveTab("associate");
  
    const selectedUser = userMemberData.find((item) => item.id === 2);
    if (selectedUser) {
      handleOpenModal(selectedUser);
    }
  };
  

  return (
    <>
      <ToastMessage />
      <section className="user_div_total">
        <Header />
        <div className="container pt-5">
          <div className="row">
            {userMemberData.map((item) => (
              <div className="col-md-4" key={item.id}>
                <div className="card">
                  <div className="body card_hover pad_block_45">
                    <div className="member_appliction_page_heading">
                      {item.application_name}
                    </div>
                    <div className="text-center">
                      <h4 className="h4 pb-4 mb-0 font-weight-bold text-cyan">
                        {item.totalPrice ? `${item.currency_symbol} ${item.totalPrice}` : "Free Of Charge"} /-
                      </h4>
                    </div>
                    <div className="text-center">
                      <button onClick={() => handleOpenModal(item)} className="btn btn-outline-info">
                        View Details & Apply
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {isModal === "Form Wizard modal" && selectedApplication && (
            <div className="modal fade Form-Wizard-modal d-block show">
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {selectedApplication.application_name || "Life Member"}
                    </h5>
                    <button type="button" className="close" onClick={handleCloseModal}>
                      <span>&times;</span>
                    </button>
                  </div>
                  <div className="modal-body pricing_page role_table application_check check_box_clr_change">
                    <div id="wizard_horizontal">
                      {selectedApplication.description && (
                        <div className="member_chck_box_div">
                          <p><b>Eligibility Criteria:</b></p>
                          {extractListItems(selectedApplication.description).map((text, index) => (
                            <div key={index} className={`${[1,2,4].includes(selectedApplication.id)?'alm_div':''} d-flex align-items-center check_elig_div`}>
                              <FormCheck
                                type="checkbox"
                                key={`eligibility-${index}`}
                                id={`eligibility-${index}`}
                                checked={checkedItems[index] || false}
                                onChange={() => handleCheckboxChange(index)}
                                label={text}
                              />
                              {/* <label htmlFor={`eligibility-${index}`} className="ml-2">{text}</label> */}
                            </div>
                          ))}
                        </div>
                      )}

                      {selectedApplication.documents_description && (
                        <div className="member_chck_box_div pt-2 pb-3 document_div_check">
                          <p><b>Documents Required:</b></p>
                          {extractListItems(selectedApplication.documents_description).map((text, index) => (
                            <div key={index + 100} className="d-flex align-items-center">
                              <FormCheck
                                type="checkbox"
                                key={`document-${index + 100}`}
                                id={`document-${index + 100}`}
                                checked={checkedItems[index + 100] || false}
                                onChange={() => handleCheckboxChange(index + 100)}
                                label={text}
                              />
                              {/* <label htmlFor={`document-${index + 100}`} className="ml-2">{text}</label> */}
                            </div>
                          ))}
                        </div>
                      )}
                      {selectedApplication.id===1 &&
                      <div>
                        <div className="membership-box pb-3">
                          <div className="membership-alert">
                            <HiOutlineExclamationCircle size={35} />
                            <p>
                              <strong>Important:</strong>   ASI membership certificate is mandatory for Life Membership. If you don't have an ASI certificate, please consider applying for Associate Life Membership instead.
                            </p>
                          </div>
                        </div>
                        <div className="membership-actions">
                          <div className="membership-tabs">
                            <div className={`tab-option active`} onClick={() => setActiveTab('life')}>
                              Life Member
                            </div>
                            <div className={`tab-option`} onClick={() => handleOpenALMApplication()}>
                              Associate Life Member
                            </div>
                          </div>
                        </div>
                      </div>
                      }
                      {(selectedApplication.currency_code === "INR" ||
                        selectedApplication.currency_code === "USD") && (
                          <>
                            {" "}
                            <p>
                              <b>Fee Table</b>
                            </p>
                            <div className="body">
                              <div className="table-responsive">
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      {selectedApplication.currency_code ===
                                        "INR" && (
                                          <>
                                            <th>Membership Fee</th>
                                            <th>GST</th>
                                            <th>Total</th>
                                          </>
                                        )}
                                      {selectedApplication.currency_code ===
                                        "USD" && (
                                          <>
                                            <th>Membership Fee</th>
                                            <th>Processing Fee</th>
                                          </>
                                        )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>{selectedApplication.fee}</td>

                                      {selectedApplication.currency_code ===
                                        "INR" && (
                                          <>
                                            {/* <td>{selectedApplication.gst}</td> */}
                                            <td>{selectedApplication.gstAmount}</td>
                                            <td>
                                              {/* {parseInt(selectedApplication.fee) +
                                              parseInt(selectedApplication.gst)} */}
                                              {selectedApplication.totalPrice}
                                            </td>
                                          </>
                                        )}

                                      {selectedApplication.currency_code ===
                                        "USD" && (
                                          <>
                                            <td>
                                              {selectedApplication.processing_fee
                                                ? `${selectedApplication.processing_fee} %`
                                                : "N/A"}
                                            </td>
                                          </>
                                        )}
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </>
                        )}
                      <div className="col-md-12">
                        <div className="apply_cancel_button">
                          <button onClick={handleCloseModal} className="btn btn-danger">
                            Cancel
                          </button>
                          <button onClick={() => handleOpenApplicationForm(`${ROUTE_BASE_URL}/user-member-application/${encryptSlug(`${selectedApplication.id}`)}`)} className="btn btn-info">
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <Footer/>
      </section>
    </>
  );
};

export default UserMemberApplicationList;



// import React, { useState, useEffect } from "react";
// import { Link, useHistory } from 'react-router-dom';
// import { GetUserMemberApplicationData } from "../../components/UserMembershipApplication/Api/services/Webservices";
// import Header from "./Header";
// import { ROUTE_BASE_URL } from "../../api/common";
// import { FormCheck } from "react-bootstrap";
// import { showToast, ToastMessage } from "../Shared/ToastMessage";

// const UserMemberApplicationList = () => {

//   const history = useHistory();

//   const [isModal, setModal] = useState("");
//   const [userMemberData, setUserMemberData] = useState([]);
//   const [selectedApplication, setSelectedApplication] = useState(null);
//   const [checkEligibility, setCheckEligibility] = useState(false);
//   const [checkDocument, setCheckDocument] = useState(false);

//   useEffect(() => {
//     GetUserMemberApplicationData()
//       .then((res) => {
//         console.log(res, "UserMemberData");
//         setUserMemberData(res.data);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }, []);

//   const handleOpenModal = (item) => {
//     setSelectedApplication(item);
//     setModal("Form Wizard modal");
//   };

//   const handleCloseModal = (item) => {
//     setCheckDocument(false);
//     setCheckEligibility(false);
//     setSelectedApplication(null);
//     setModal("");
//   };
//   const handleOpenApplicationForm = (url) => {
//     if( (!checkEligibility&&selectedApplication.description) ||
//     (!checkDocument&&selectedApplication.documents_description)){
//       showToast("Please review all the necessary documents and check the box before proceeding to the next step.", "error", 8000);
//       return;
//     }else{
//       history.replace(url);
//     }
//   };

//   return (
//     <>
//       <ToastMessage />
//       <section className="user_div_total">
//         <Header/>
//         <div className="container pt-5">
//           <div className="row">
//             {userMemberData &&
//               userMemberData.map((item) => (
//                 <div className="col-md-4" key={item.id}>
//                   <div className="card">
//                     <div className="body">
//                       <div className="member_appliction_page_heading">
//                         {item.application_name}
//                       </div>
//                       <div className="text-center">
//                         <h4 className="h4 py-4 mb-0 font-weight-bold text-cyan">
//                           {item.totalPrice
//                             ? `${item.currency_symbol} ${item.totalPrice}`
//                             : "Free Of Charge"}
//                           /-
//                         </h4>
//                       </div>

//                       <div className="text-center">
//                         <div className="ml-auto">
//                           <button
//                             onClick={() => handleOpenModal(item)}
//                             className="btn btn-outline-info"
//                           >
//                             View Details & Apply
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//           </div>
//           <div
//             className={`modal fade Form-Wizard-modal ${
//               isModal === "Form Wizard modal" ? "d-block show" : ""
//             }`}
//           >
//             <div
//               className="modal-dialog modal-lg"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div className="modal-content">
//                 <div className="modal-header">
//                   <h5 className="modal-title" id="exampleModalLabel">
//                     {selectedApplication
//                       ? selectedApplication.application_name
//                       : "Life Member"}{" "}
//                   </h5>
//                   <button
//                     type="button"
//                     className="close"
//                     data-dismiss="modal"
//                     aria-label="Close"
//                     onClick={() => handleCloseModal()}
//                   >
//                     <span aria-hidden="true">×</span>
//                   </button>
//                 </div>
//                 <div className="modal-body pricing_page role_table">
//                   <div id="wizard_horizontal">
//                     {selectedApplication && (
//                       <>
//                         {selectedApplication && (
//                           <>
//                           {selectedApplication.description&&
//                           // <div className="eligibility_req_flex">
//                           //   <p>
//                           //     <FormCheck
//                           //         type="checkbox"
//                           //         id="checkbox-eligibility"
//                           //         label=""
//                           //         checked={checkEligibility}
//                           //         onChange={(e) => {
//                           //           setCheckEligibility(e.target.checked);
//                           //         }}
//                           //       />
//                           //     The eligibility criteria to become a{" "}
//                           //     <b>{selectedApplication? selectedApplication.application_name: "Life Member"} :</b>
//                           //   </p>
//                           //   </div>
//                           <div className="eligibility_req_flex">
//                             <FormCheck
//                               type="checkbox"
//                               id="checkbox-eligibility"
//                               label={
//                                 <p>
//                                   The eligibility criteria to become a{" "}
//                                   <b>{selectedApplication?.application_name ?? "Life Member"} :</b>
//                                 </p>
//                               }
//                               checked={checkEligibility}
//                               onChange={(e) => setCheckEligibility(e.target.checked)}
//                             />
//                           </div>

//                             }
//                             <div
//                               dangerouslySetInnerHTML={{
//                                 __html: selectedApplication.description,
//                               }}
//                             />
//                             {/* <div className="document_req_flex">
//                               <p>
//                               <FormCheck
//                                   type="checkbox"
//                                   id="checkbox-document"
//                                   label=""
//                                   checked={checkDocument}
//                                   onChange={(e) => {
//                                     setCheckDocument(e.target.checked);
//                                   }}
//                                 />
//                                 Documents required
//                               </p>
//                             </div> */}
//                             <div className="document_req_flex">
//                               <FormCheck
//                                 type="checkbox"
//                                 id="checkbox-document"
//                                 label={<p><b>Documents required</b></p>}
//                                 checked={checkDocument}
//                                 onChange={(e) => setCheckDocument(e.target.checked)}
//                               />
//                             </div>
//                             <div
//                               dangerouslySetInnerHTML={{
//                                 __html:
//                                   selectedApplication.documents_description,
//                               }}
//                             />
//                           </>
//                         )}
//                         {(selectedApplication.currency_code === "INR" ||
//                           selectedApplication.currency_code === "USD") && (
//                           <>
//                             {" "}
//                             <p>
//                               <b>Fee Table</b>
//                             </p>
//                             <div className="body">
//                               <div className="table-responsive">
//                                 <table className="table table-bordered">
//                                   <thead>
//                                     <tr>
//                                       {selectedApplication.currency_code ===
//                                         "INR" && (
//                                         <>
//                                           <th>Membership Fee</th>
//                                           <th>GST</th>
//                                           <th>Total</th>
//                                         </>
//                                       )}
//                                       {selectedApplication.currency_code ===
//                                         "USD" && (
//                                         <>
//                                           <th>Membership Fee</th>
//                                           <th>Processing Fee</th>
//                                         </>
//                                       )}
//                                     </tr>
//                                   </thead>
//                                   <tbody>
//                                     <tr>
//                                       <td>{selectedApplication.fee}</td>

//                                       {selectedApplication.currency_code ===
//                                         "INR" && (
//                                         <>
//                                           {/* <td>{selectedApplication.gst}</td> */}
//                                           <td>{selectedApplication.gstAmount}</td>
//                                           <td>
//                                             {/* {parseInt(selectedApplication.fee) +
//                                               parseInt(selectedApplication.gst)} */}
//                                               {selectedApplication.totalPrice}
//                                           </td>
//                                         </>
//                                       )}

//                                       {selectedApplication.currency_code ===
//                                         "USD" && (
//                                         <>
//                                           <td>
//                                             {selectedApplication.processing_fee
//                                               ? `${selectedApplication.processing_fee} %`
//                                               : "N/A"}
//                                           </td>
//                                         </>
//                                       )}
//                                     </tr>
//                                   </tbody>
//                                 </table>
//                               </div>
//                             </div>
//                           </>
//                         )}
//                       <div className="col-md-12">
//                       <div className="apply_cancel_button">
//                         <button
//                           onClick={() => handleCloseModal()}
//                           className="btn btn-danger"
//                         >
//                           Cancel
//                         </button>
//                         {/* <Link
//                           to={`${ROUTE_BASE_URL}/user-member-application/${
//                             selectedApplication?.id ?? 1
//                           }`}
//                         > */}
//                           <button
//                             // disabled={
//                             //   (!checkEligibility&&selectedApplication.description) ||
//                             //   (!checkDocument&&selectedApplication.documents_description)
//                             // }
//                             onClick={()=>handleOpenApplicationForm(`${ROUTE_BASE_URL}/user-member-application/${selectedApplication?.id ?? 1}`)}
//                             className="btn btn-info"
//                           >
//                             Apply
//                           </button>
//                         {/* </Link> */}
//                       </div>
//                     </div>
//                       </>
//                     )}

//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default UserMemberApplicationList;
